module.exports = __webpack_public_path__ + "media/images/map-a0315a95ec62733878f9117e39bf86a1.jpg";